/**
 * Enum used by planners when "showMeasurementSystemSwitch" is true to allow users to switch between metric and imperial (controlled by planner).
 */
enum MeasurementSystemEnum {
	metric = 'metric',
	imperial = 'imperial'
}

export default MeasurementSystemEnum;
